import React, { useState } from 'react';
import usePendingApprovalRequestsData from './hooks/usePendingApprovalRequestsData';
import PendingApprovalRequestsTable from './components/PendingApprovalRequestsTable';
import BulkResultDialog from './components/BulkResultDialog';
import ApprovalModal from '../warranty-requests/warranty-claims/createEditForm/component/ApprovalModal';
import { useLanguage } from '../../../contexts/LanguageContext';
import { Button } from 'primereact/button';
import toastService from '../../../utils/toastService';

const PendingApprovalRequests = () => {
    const { th } = useLanguage();
    const [returnModalVisible, setReturnModalVisible] = useState(false);
    const [bulkResultData, setBulkResultData] = useState(null);
    const [bulkResultDialogVisible, setBulkResultDialogVisible] = useState(false);
    const [bulkResultType, setBulkResultType] = useState('accept');

    const { 
        apiPendingRequests, 
        isLoading, 
        lazyParams, 
        sortField,
        sortOrder,
        activeFilters,
        onPage, 
        onSort,
        handleFilterChange, 
        initFilters, 
        dealerOptions,
        dealerFilterValue,
        setDealerFilterValue,
        setDealerSearchText,
        dealerCodeOptions,
        dealerCodeFilterValue,
        setDealerCodeFilterValue,
        setDealerCodeSearchText,
        warrantyTypeOptions,
        countryOptions,
        warrantyTypeFilterValue,
        setWarrantyTypeFilterValue,
        selectedRequests, 
        setSelectedRequests,
        selectAll,
        handleSelectAll,
        handleAccept, 
        handleReturn, 
        isAccepting, 
        isReturning,
        isBulkProcessing
    } = usePendingApprovalRequestsData();

    // Kabul Et tıklandığında; bulk ise sonuç dialogunu göster
    const handleAcceptClick = async () => {
        const result = await handleAccept();
        if (result?.data && typeof result.data === 'object') {
            setBulkResultType('accept');
            setBulkResultData(result.data);
            setBulkResultDialogVisible(true);
        }
    };

    // İade Et butonuna tıklandığında
    const handleReturnClick = async () => {
        if (selectedRequests.length === 0) {
            toastService.warn(th('pendingApprovalRequests.toast.selectAtLeastOne'));
            return;
        }

        if (selectedRequests.length === 1) {
            setReturnModalVisible(true);
        } else {
            const result = await handleReturn('');
            if (result?.data && typeof result.data === 'object') {
                setBulkResultType('return');
                setBulkResultData(result.data);
                setBulkResultDialogVisible(true);
            }
        }
    };

    // Modal'dan gelen statusDescription ile iade et
    const handleReturnConfirm = (statusDescription) => {
        handleReturn(statusDescription);
        setReturnModalVisible(false);
    };


    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('pendingApprovalRequests.title')}</h1>
            </div>

            <div className="mb-3 flex gap-2">
                <Button label={th('pendingApprovalRequests.buttons.accept')} icon="pi pi-check" onClick={handleAcceptClick} disabled={selectedRequests.length === 0 || isAccepting || isReturning || isBulkProcessing} loading={isAccepting || isBulkProcessing} severity="success" />
                <Button label={th('pendingApprovalRequests.buttons.return')} icon="pi pi-replay" onClick={handleReturnClick} disabled={selectedRequests.length === 0 || isAccepting || isReturning || isBulkProcessing} loading={isReturning || isBulkProcessing} severity="warning" />
            </div>

            <PendingApprovalRequestsTable
                requests={apiPendingRequests?.items}
                totalCount={apiPendingRequests?.totalCount}
                lazyParams={lazyParams}
                onPage={onPage}
                loading={isLoading}
                selectedRequests={selectedRequests}
                setSelectedRequests={setSelectedRequests}
                selectAll={selectAll}
                onSelectAllChange={handleSelectAll}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                onResetFilters={initFilters}
                dealerOptions={dealerOptions}
                dealerFilterValue={dealerFilterValue}
                setDealerFilterValue={setDealerFilterValue}
                setDealerSearchText={setDealerSearchText}
                dealerCodeOptions={dealerCodeOptions}
                dealerCodeFilterValue={dealerCodeFilterValue}
                setDealerCodeFilterValue={setDealerCodeFilterValue}
                setDealerCodeSearchText={setDealerCodeSearchText}
                warrantyTypeOptions={warrantyTypeOptions}
                countryOptions={countryOptions}
                warrantyTypeFilterValue={warrantyTypeFilterValue}
                setWarrantyTypeFilterValue={setWarrantyTypeFilterValue}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
            />

            <ApprovalModal visible={returnModalVisible} onHide={() => setReturnModalVisible(false)} onConfirm={handleReturnConfirm} type="back" />

            <BulkResultDialog
                visible={bulkResultDialogVisible}
                data={bulkResultData}
                type={bulkResultType}
                onHide={() => {
                    setBulkResultDialogVisible(false);
                    setBulkResultData(null);
                }}
            />
        </div>
    );
};

export default PendingApprovalRequests;
